import React from 'react';

const SendSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        d='M21 10.4667C21.0009 10.8889 20.8808 11.3026 20.6536 11.6598C20.4265 12.017 20.1016 12.303 19.7168 12.4845L3.22593 20.2213C2.92411 20.3843 2.58975 20.4794 2.24661 20.5C1.87111 20.4992 1.50177 20.4054 1.17222 20.2272C0.842661 20.0489 0.563359 19.7919 0.359739 19.4794C0.156119 19.167 0.034648 18.809 0.00638611 18.4382C-0.0218758 18.0674 0.0439688 17.6954 0.197925 17.3562L2.76441 11.5815H9.00053C9.29908 11.5815 9.58539 11.4641 9.79649 11.255C10.0076 11.046 10.1262 10.7624 10.1262 10.4667C10.1262 10.1711 10.0076 9.88752 9.79649 9.67845C9.58539 9.46938 9.29908 9.35193 9.00053 9.35193H2.76441L0.197925 3.63297C0.0119581 3.21738 -0.0413011 2.75542 0.0452857 2.30901C0.131872 1.8626 0.354168 1.45307 0.68238 1.13529C1.01059 0.817523 1.42904 0.606697 1.88164 0.531073C2.33423 0.455448 2.79936 0.518639 3.21468 0.712175L19.7055 8.44894C20.0924 8.62886 20.4197 8.91416 20.6489 9.27149C20.8781 9.62881 20.9999 10.0434 21 10.4667Z'
        fill={color}
      />
    </svg>
  );
};

export default SendSVG;
